import { useBreakpointValue } from '@gemini/core';
export const useBreakpoint = () => {
    const device = useBreakpointValue({
        base: 'mobile',
        sm: 'tablet',
        xl: 'desktop',
    });
    return {
        isDesktop: device === 'desktop',
        isMobile: device === 'mobile',
        isTablet: device === 'tablet',
    };
};
